import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => KeyValueComponent),
    multi: true
};

@Component({
    selector: 'chassis-key-value',
    templateUrl: './key-value.component.html',
    styleUrls: ['./key-value.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class KeyValueComponent extends InputComponent implements OnInit {

    /**
     * ID input
     */
    @Input() id: string;

    /**
     * Select single or multiple items?
     *
     * @type {boolean}
     */
    @Input() single = false;

    /**
     * Backend errors
     */
    @Input() errors;

    /**
     * Construct
     *
     * @param injector
     */
    constructor(protected injector: Injector) {
        super(injector);
    }

    /**
     * Init
     */
    public ngOnInit() {

        if (!this.id) {
            this.id = Math.floor(Math.random() * 10000) + '';
        }

        console.log('init key value', this.val);

    }

    /**
     * Add new row
     *
     */
    public addRow() {
        if (!this.val) {
            this.val = [];
        }

        if (!this.val) {
            this.val = [];
        }

        console.log('add row', this.val);

        this.val.push({key: '', value: '', default: false});
    }

    /**
     * Make sure all rows default to false
     *
     * @param selectedRow
     */
    public selectDefault(selectedRow) {
        this.val.forEach(row => {
            row.default = false;
        });

        selectedRow.default = true;
    }

    public deleteOption(index) {
        this.val.splice(index, 1);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/key-value/key-value.component.ts